module.exports = __webpack_public_path__ + "img/map.c3e00717.svg";